export type EmailIconProps = {
    color?: string;
    height?: number;
    width?: number;
};

export const EmailIcon = ({
    color = "currentColor",
    height = 15,
    width = 20
}: EmailIconProps) => {
    return (
        <svg
            viewBox="0 0 20 15"
            height={height}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <g fill={color}>
                <path d="m2.5 2.5v10h15v-10zm-2.5-.83742559c0-.91821449.75960159-1.66257441 1.67078882-1.66257441h16.65842238c.9227512 0 1.6707888.74385233 1.6707888 1.66257441v11.67485119c0 .9182145-.7596016 1.6625744-1.6707888 1.6625744h-16.65842238c-.92275118 0-1.67078882-.7438523-1.67078882-1.6625744z" />
                <path d="m1.72652251.25537511-1.48964008 2.01831895 9.76654427 6.46055241 9.6627916-6.40809291-1.3864108-2.09057502-8.2798075 5.46912408z" />
            </g>
        </svg>
    );
};
